export default __webpack_public_path__ + "static/media/next.ad3c2e04.svg";